import { getStudentUrl } from '@magicschool/utils/nextjs/url';

export const buildStudentUrl = (requireLogin: boolean, joinCode: string | null, roomStudentId?: string) => {
  const sessionId = roomStudentId && !requireLogin ? roomStudentId : null;
  const path = requireLogin ? 'login' : 'join';

  const url = new URL(`/s/${path}`, getStudentUrl());
  if (sessionId) url.searchParams.set('sessionId', sessionId);
  if (joinCode) url.searchParams.set('joinCode', joinCode);

  return url.toString();
};
